const SET_HAPPENING = 'SET_HAPPENING';
const SET_STORE_AVAILABILITIES = 'SET_STORE_AVAILABILITIES';

export {
    SET_HAPPENING, SET_STORE_AVAILABILITIES
};
